<template>
    <div class="edit_wrap">
        <div class="add_top">
            <div class="add_tab" :class="[isType==1 ? 'active_tab' : '']" @click="changeTab(1)">申请大V店已有品牌</div>
            <div class="add_tab" :class="[isType!=1 ? 'active_tab' : '']" @click="changeTab(2)">添加新品牌</div>
        </div>
        <oldBrand v-show="isType == 1"></oldBrand>
        <newBrand v-show="isType != 1"></newBrand>
    </div>
</template>

<script type="text/javascript">
    import oldBrand from './old_brand.vue'
    import newBrand from './new_brand.vue'
    export default {

        components: {
            oldBrand: oldBrand,
            newBrand: newBrand,
        },
        data () {
            return {
                isType: 1,
                brandApplyId: 0
            }
        },
        methods: {
            changeTab(step){
                if (this.brandApplyId > 0) {

                } else {
                    this.isType = step;
                    this.$route.query.isType = step;
                }
            }
        },
        mounted(){
            this.brandApplyId = this.$route.query.brandApplyId;
            var type=this.$route.query.isType;
            type = type * 1;
            if(type && type>0 && type <=2) {
                this.isType = type;
            }
        }
    };
</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
    .add_top {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
    }
    .add_tab {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .active_tab {
        border-bottom: 1px solid #ff4a7d;
        color: #ff4a7d;
    }
    }
</style>


// WEBPACK FOOTER //
// addBrandCommonPages.vue?6bcbf5b6